<template>
  <div>
    <div>
      <h3 class="h5">Stap 1: Selecteer agenda's</h3>

      <FormKit
        label="Selecteer agenda"
        type="select"
        @change="setSelectedAgenda"
        placeholder="Selecteer agenda"
      >
        <optgroup
          v-for="(activity, index) in formattedActivities"
          :label="activity.title"
          :key="index"
        >
          <option
            v-for="agenda in activity.agendas"
            :key="agenda.id"
            :value="agenda.value"
          >
            {{ agenda.label }}
          </option>
        </optgroup>
      </FormKit>
    </div>

    <hr v-show="selectedAgendas.length > 0"/>

    <div
      v-for="activity in selectedAgendasModels"
      :key="`activity-${activity.id}`"
      class="mb-1"
    >
      <h4 class="h6" style="font-weight: bold">{{ activity.title }}</h4>

      <div
        v-for="agenda in activity.agendas"
        :key="`agenda-${agenda.id}`"
        class="d-flex justify-content-between mb-1"
      >
        <p>{{ agenda.description }}</p>
        <button
          @click="removeAgenda(agenda.id)"
          class="btn btn-danger"
        >
          <i class="lar la-trash-alt mr-2"></i> Verwijder agenda
        </button>
      </div>
    </div>

    <div class="mb-4" v-show="selectedAgendas.length > 0">
      <h3 class="h5">Stap 2: Selecteer de dag en tijd</h3>

      <FormKit type="form" @submit="addSlot" :key="key" :actions="false">
        <div class="row">
          <div class="col-12 col-lg-5">
            <FormKit
              type="select"
              :options="days"
              name="day"
              label="Dag in de week"
              v-model="form.day"
              validation="required"
            />
          </div>

          <div class="col-12 col-lg-5 time-val">
            <FormKit
              type="time"
              name="time"
              label="Tijd"
              v-model="form.time"
              validation="required"
              @keydown.enter="focusHourInput"
            />
          </div>

          <div class="col-12 col-lg-2 d-flex align-items-end">
            <FormKit :classes="{input: 'btn btn-primary'}" type="submit" label="+ Slot toevoegen"/>
          </div>
        </div>
      </FormKit>

      <hr/>

      <div
        v-for="(group, index) in timesGrouped"
        :key="`group-${index}`"
        class="mb-3"
      >
        <h6 class="h6 fw-semibold mb-0">{{ group.day }}</h6>

        <div v-if="group.times.length > 0" class="d-flex flex-wrap">
          <div
            v-for="(time, index) in group.times"
            :key="`time-${index}`"
            class="px-2 py-2 border my-2 mr-2"
          >
            {{ time.time }}
            <button
              class="ml-2 btn btn-danger"
              @click="deleteTime(group.__original, time)"
            >
              <i class="lar la-trash-alt mr-2"></i> Verwijder tijdslot
            </button>
          </div>
        </div>
        <div v-else>
          <span>Nog geen tijssloten aangemaakt</span>
        </div>
      </div>

    </div>

    <button @click="saveSlots" class="btn btn-primary" v-show="times.length > 0">
      Tijdsloten toevoegen
    </button>

    <span class="alert alert-success d-block mt-3" v-if="!!alert">
            {{ alert }}
        </span>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    activities: {
      type: Array,
    },
    maison: {
      type: Object,
    },
  },
  data() {
    return {
      selectedAgendas: [],
      times: [],
      key: 0,
      alert: null,
      days: [
        {label: "Maandag", value: 1},
        {label: "Dinsdag", value: 2},
        {label: "Woensdag", value: 3},
        {label: "Donderdag", value: 4},
        {label: "Vrijdag", value: 5},
        {label: "Zaterdag", value: 6},
        {label: "Zondag", value: 0},
      ],
      form: {
        day: 1,
        time: "",
      },
    };
  },
  methods: {
    focusHourInput(e) {
      const timeInput = e.target.closest('.time-val');
      if (timeInput) {
        const input = timeInput.querySelector('input[type="time"]');
        if (input) {
          setTimeout(() => {
            input.blur();
            input.focus();
          }, 100);
        }
      }
    },
    setSelectedAgenda(e) {
      let value = parseInt(e.target.value);

      if (!value) {
        return;
      }

      this.selectedAgendas.push(value);
    },
    addSlot(values) {
      let exists = !!_.find(this.times, {
        day: values.day,
        time: values.time,
      });

      if (exists) {
        return;
      }

      this.times.push({...values});
      this.form.time = "";
    },
    removeAgenda(id) {
      this.selectedAgendas = _.filter(
        this.selectedAgendas,
        (agendaId) => id !== agendaId
      );
    },
    deleteTime(index, time) {
      let timeIndex = _.findIndex(this.times, {day: index, time});

      if (!timeIndex) {
        return;
      }

      this.times.splice(timeIndex, 1);
    },
    async saveSlots() {
      if (this.times.length < 1 || this.selectedAgendas.length < 1) {
        return;
      }

      await axios.post(`/admin/bulk`, {
        maison: this.maison.id,
        agendas: [...this.selectedAgendas],
        slots: [...this.times],
      });

      this.alert = "Tijdsloten opgeslagen";
      this.times = [];
      this.selectedAgendas = [];
      this.$emit("on-update");
    },
  },
  computed: {
    formattedActivities() {
      const activities = [];

      for (let activity of this.activities) {
        let object = {
          title: activity.title,
          agendas: [],
        };

        for (let agenda of activity.agendas) {
          if (this.selectedAgendas.includes(agenda.id)) {
            continue;
          }

          object.agendas.push({
            value: agenda.id,
            label: agenda.description,
          });
        }

        activities.push(object);
      }

      return activities;
    },
    selectedAgendasModels() {
      const activities = [];

      for (let activity of this.activities) {
        let agendas = _.filter(activity.agendas, (agenda) => {
          return this.selectedAgendas.includes(agenda.id);
        });

        if (agendas.length < 1) {
          continue;
        }

        let foundActivity = {
          id: activity.id,
          title: activity.title,
          agendas: [],
        };

        for (let agenda of agendas) {
          foundActivity.agendas.push(agenda);
        }

        activities.push(foundActivity);
      }

      return activities;
    },
    timesGrouped() {
      let days = this.days;

      let availabilityGroupedByDay = [];
      for (let day of days) {
        let times = _.filter(
          this.times,
          (time) => +time.day == +day.__original
        );

        if (times.length > 0) {
          availabilityGroupedByDay.push({
            day: day.label,
            index: day.value,
            times,
          });
        }
      }

      return availabilityGroupedByDay;
    },
  },
  watch: {
    maison() {
      this.times = [];
      this.selectedAgendas = [];
    },
  },
};
</script>

<style lang="scss">
.time-val {
    .formkit-messages {
        display: none;
    }
}
</style>
